package com.yendo.mx.ui.home

import androidx.compose.runtime.Immutable
import androidx.compose.runtime.Stable
import com.yendo.mx.models.RestauranteFirebase

/**
 * 🚀 MODELO UI INMUTABLE (@Immutable y @Stable)
 * Permite que Jetpack Compose active la omisión de recomposición (Skipping) al 100%
 * durante el desplazamiento rápido por la LazyColumn.
 */
@Immutable
@Stable
data class FilaRestaurantesState(
    val idKey: String,
    val restaurantes: List<RestauranteFirebase>
)
